// components/assigned-tasks/QuickTasksSection.jsx
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import DaysLeft from "../modules/days-left/days-left.component";
import Priority from "../modules/priority/priority.component";
import CreatedBy from "../modules/created-by/created-by.component";
import RetroButton from "../retro/button/retro-button.component";

import RetroInput from "../retro/input/input.component";
import CheckBox from "../ui-elements/checkbox";

import {
  db,
  createNewInboxTask,
  updateInboxTaskAsDone,
} from "../../firebase/firebase.utils";

import "./assigned-tasks.styles.scss";

import { IoLeafSharp } from "react-icons/io5";
import { BsPlus } from "react-icons/bs";
import { FiSquare, FiCheckSquare } from "react-icons/fi";

const QuickTasksSection = ({ color, name, inboxTasks, expandAll }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (expandAll !== null) {
      setIsOpen(expandAll);
    }
  }, [expandAll]);

  const [newTaskName, setNewTaskName] = useState("");
  const inputRef = useRef();

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    createNewInboxTask(currentUser.uid, newTaskName, null);
    inputRef.current.value = "";
    inputRef.current.blur();
  };

  const handleCheck = (task, done) => {
    document.getElementById("done_tone").play();
    const IdRef = currentUser.uid;
    if (task.done) {
      updateInboxTaskAsDone(IdRef, task.id, false);
    } else {
      updateInboxTaskAsDone(IdRef, task.id, true);
      console.log("it says it is not done!");
    }
  };

  const handleEventClick = (task, event) => {
    const rect = event.currentTarget
      .closest(".personalItem_Item")
      .getBoundingClientRect();

    navigate(`task/${task.id}`, {
      state: {
        taskOrigin: {
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        },
      },
    });
  };

  return (
    <div className={`personalItem_WSDetails ${isOpen ? "open" : ""}`}>
      <button
        type="button"
        className="personalItem_WSSummary"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="at__fromspace-list-btn">
          <RetroButton style={{ background: "#1A82C4", color: "white" }}>
            <IoLeafSharp strokeWidth="0.1" />
          </RetroButton>
          <h4>{name}</h4>
        </div>
      </button>

      <div className="wsDetailsContent">
        <div className="wsDetailsContent_Inner">
          {inboxTasks
            .filter((task) => task.type === "task")
            .map((task) => {
              // const { fromSpaceId, fromStationId } = task;
              return (
                <div
                  key={task.id}
                  className="fc-event personalItem_Item"
                  id={task.id}
                  done={task.done}
                  title={task.title}
                  start={task.startdate}
                  end={task.enddate}
                  duration={task.duration}
                  fromSpaceId={task.fromSpaceId}
                  fromStationId={task.fromStationId}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        columnGap: "5px",
                        pointerStyle: "cursor",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }}
                    >
                      <div className="at__check-and-name">
                        <div
                          className="at__checkBox"
                          onClick={(id, done) => handleCheck(task, done)}
                        >
                          {task.done ? <FiCheckSquare /> : <FiSquare />}
                        </div>
                        <audio
                          id="done_tone"
                          src="/media/mixkit-cool-interface-click-tone-2568.wav"
                        ></audio>
                        <div
                          className="at__content"
                          onClick={(event) => handleEventClick(task, event)}
                        >
                          <p>{task.title}</p>
                        </div>
                      </div>
                      <div className="at__modules">
                        <div className="at__daysLeft">
                          <DaysLeft task={task} />
                        </div>
                        <div className="at__priority">
                          <Priority task={task} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          <form
            className="addQuickBtn"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <BsPlus />
            <input
              ref={inputRef}
              type="text"
              value={newTaskName}
              placeholder="Add Quick Task"
              onChange={(e) => setNewTaskName(e.target.value)}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuickTasksSection;
